import { createTyper } from "@mobx/services/http";
import { Method, RequestArgs, RequestHandle } from "wl-net";

export const SetMinerNotes_RequestTypes = createTyper({
  makeRequest(
    handle: RequestHandle,
    minerID: number,
    userNote: string,
  ): RequestArgs<{ miner_id: number, user_note: string }> {
    return {
      handle,
      method: Method.Post,
      URL: `/note/set`,
      payload: { miner_id: minerID, user_note: userNote },
    };
  },
});

export const DeleteMinerNotes_RequestTypes = createTyper({
  makeRequest(
    handle: RequestHandle,
    minerID: number,
  ): RequestArgs<{ miner_id: number }> {
    return {
      handle,
      method: Method.Post,
      URL: `/note/delete`,
      payload: { miner_id: minerID },
    };
  },
});